

export const DeleteIcon = () => {
  return (

    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.96875 3.51562H16.0312M6.1875 3.51562C6.1875 1.96232 7.44669 0.703125 9 0.703125C10.5533 0.703125 11.8125 1.96232 11.8125 3.51562M14.625 6.32812V14.4844C14.625 16.0377 13.3658 17.2969 11.8125 17.2969H6.1875C4.63419 17.2969 3.375 16.0377 3.375 14.4844V3.51562" stroke="#A3A3A3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.19922 13.0781V7.73438M10.9117 13.0781V7.73438" stroke="#4CBC18" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}
